var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper",class:[_vm.inline ? 'inline' : '']},[_c('div',{staticClass:"icon",class:[
      !_vm.customSize ? `size-${_vm.size}` : '',
      `${_vm.cssType}`,
      `color-${_vm.color}`,
      _vm.outline ? 'outline' : ''
    ],style:(_vm.customProps)},[_c('svg-icon',_vm._g({attrs:{"name":`n_${_vm.name}`,"stroke-width":_vm.strokeWidth}},_vm.$listeners))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }